import { render, staticRenderFns } from "./main-efficient.vue?vue&type=template&id=d5a4a2ec"
import script from "./main-efficient.vue?vue&type=script&lang=js"
export * from "./main-efficient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports